import React from 'react';

interface ChevronRightProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
}

/**
 * Chevron right icon SVG component
 *
 * @param fill - Fill color for the chevron (defaults to the theme text color)
 * @param props additional SVG props
 */
const ChevronRight: React.FC<ChevronRightProps> = ({
  fill = 'var(--text-primary)',
  ...props
}) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.47003 4L5.53003 4.94L8.58336 8L5.53003 11.06L6.47003 12L10.47 8L6.47003 4Z'
      fill={fill}
    />
  </svg>
);

export default ChevronRight;
